<template>
  <div class="dnaKits">
    <vx-card class="mb-2">
      <vs-row class="" vs-align="center" vs-justify="space-between">
        <vs-col vs-w="3" >
          <div>
            <h4>Search</h4>
          </div>
        </vs-col>
        <vs-col vs-w="6">
          <!-- SEARCH INPUT -->
          <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
            type="text"
            :danger="!!errorMessage.length"
            :danger-text="errorMessage"
            placeholder="Kit Id, Order Number, or Email"
            size="large"
            v-model="searchValue"
            v-on:keyup.enter="fetchPurchasedKit()"
          />
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-progress v-if="isLoading" indeterminate color="primary" />
    <template v-if="purchasedKits">
      <div v-for="(row, index) in purchasedKits" :key="`row-${index}`" class="vx-row mt-6">
        <div v-for="(order, index) in row" :key="`order-${index}`" class="vx-col w-1/2">
          <purchased-kit :purchased-kit="order" showKits="true"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import dnaApi from "@/http/dnaApi";
import PurchasedKit from "@/views/dna/components/PurchasedKit";

export default {
  components: {
    PurchasedKit
  },
  data() {
    return {
      isLoading: false,
      searchValue: "",
      purchasedKits: null,
      errorMessage: ""
    }
  },
  mounted() {
  },
  methods: {
    async fetchPurchasedKit() {
      this.errorMessage = "";
      if (!this.validateSearchValue(this.searchValue)) {
        this.errorMessage = "Search value cannot be empty!";
        return;
      }
      this.isLoading = true;

      const results = await dnaApi.getPurchasedKitsBySearch(this.searchValue);
      this.purchasedKits = !results || !results.length ? null : _.chunk(results, 2);

      if (!this.purchasedKits || !this.purchasedKits.length) this.errorMessage = "No Results found";

      this.isLoading = false;
    },
    validateSearchValue(searchValue) {
      if (!searchValue) return false;
      this.searchValue = searchValue.trim();

      if (!this.searchValue.includes("@")) {
        this.searchValue = this.searchValue.toUpperCase();
      }

      return !(this.searchValue === "");
    }
  }
};
</script>
